import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, isColorBright, RGB_2_HEX } from '../../lib/ep.js';
import { size as _size, isEqual as _isEqual, shuffle as _shuffle } from 'lodash';
import { Stage, Layer, Rect, Group } from 'react-konva';

import Spinner from '../builder/Spinner.js';

class MemoryCanvas extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			backflip_image:props.image,
			backflip_image_obj:{},
			columns:0,
			first_element:false,
			found:[],
			full_loaded:false,
			images:props.images,
			items:[],
			last_element:false,
			loaded:0,
		};

		this.size = 600;

		this.columns = 5; // squared images of 1/5 of the canvas size per side

		this.max_rotation = 20;

		//this.foo_columns = [];
		this.loaded_images = [];
		this.backflip_image;

		this.hidden_color = 'rgba(' + props.color_ok + ', 1)';
		this.hidden_color_hover = 'rgba(' + props.color_ok + ', 0.8)';

		this.success_sound = props.sound_fx.success;
		this.flip_sound = props.sound_fx.flip;

		if(props.stageInstance != undefined)props.stageInstance(this);
	}

	/*START SOUNDS*/
	movePlay() {
		this.flip_sound.play();
	}

	errorPlay() {
		this.flip_sound.play();
	}

	successPlay() {
		this.success_sound.play();
	}

	moveAndSuccessPlay() {
		this.flip_sound.once('end', () => {
			this.successPlay();
		});
		this.flip_sound.play();
	}
	/*END SOUNDS*/

	componentWillReceiveProps(props) {
		if(!_isEqual(props.images, this.props.images)) {
			this.state.images = props.images;

			this.state.found = [];
			this.state.items = [];
			this.loaded_images = [];
			this.state.loaded = 0;

			this.setState({...this.state});
			this.loadImages();
		}

		if(props.image != this.props.image){
			this.state.backflip_image = props.image;
			this.loadBackFlipImage();
		}

		if(props.to_reset != this.props.to_reset){
			this.resetGame();
		}
	}

	componentDidMount() {
		this.loadBackFlipImage();
		this.loadImages();

		if(this.props.stageInstance != undefined) this.props.stageInstance(this);

		window.onresize = () => {
			this.gameInit(true);
		}
	}

	resetGame() {
		this.state.full_loaded = false;
		this.state.first_element = false;
		this.state.last_element = false;
		this.state.found = [];
		this.shuffle();
		this.gameInit();
	}

	gameInit(from_resize) {
		if(from_resize == undefined) from_resize = false;

		if(this.props.adaptToContainer != undefined) this.props.adaptToContainer((size) => {
			this.size = size;
			this.setState({ full_loaded:true });
		});
	}

	handleLoad(image, index) {
		var image = this.loaded_images[index];

		const new_image = {
			fillPatternImage:image,
			image_w:image.width,
			image_h:image.height,
			rotation:-this.max_rotation * Math.random() + this.max_rotation * Math.random(),
			size_piece_w:image.width / this.columns,
			size_piece_h:image.height / this.columns,
			identifier:index,
			empty:false,
		};

		this.state.items.push(new_image);
		this.state.items.push(new_image);

		if((this.state.loaded + 1) == _size(this.state.images)) this.shuffle();

		this.setState({ loaded:(this.state.loaded + 1) });

		this.total_images--;
		if (this.total_images == 0) this.gameInit();
	}

	loadImages() {
		const images = this.state.images;

		//Set columns
		const num_columns = Math.ceil(Math.sqrt(_size(images) * 2));
		this.setState({columns:num_columns});

		//this.foo_columns = [];
		//for(var i = 0; i < num_columns - 1; i++) this.foo_columns.push("foo");
		this.total_images = 0;

		images.map((source, index) => {
			this.total_images++;
			this.loaded_images[index] = new window.Image();
			this.loaded_images[index].crossOrigin = 'Anonymous';
			this.loaded_images[index].src = source;
			this.loaded_images[index].onload = () => {
				this.handleLoad(this.loaded_images[index], index)
			}
		});
	}

	loadBackFlipImage() {
		const image = this.state.backflip_image;
		this.backflip_image  = new window.Image();
		this.backflip_image.crossOrigin = 'Anonymous';
		this.backflip_image.src = this.state.backflip_image;
		this.backflip_image.onload = () => {
			var img = this.backflip_image;
			this.state.backflip_image_obj = {
				fillPatternImage:img,
				image_w:img.width,
				image_h:img.height,
				size_piece_w:img.width / this.columns,
				size_piece_h:img.height / this.columns,
			}
			this.setState({...this.state});
		}
	}

	shuffle() {
		var items = this.state.items;
		if(_size(items) > 0) {
			const first_cut = this.cutDeck(_shuffle(items));
			const second_cut = this.cutDeck(first_cut);
			const third_cut = this.cutDeck(second_cut);

			this.setState({ items:third_cut });

			//var solved = this.isSolved();
		}
	}

	cutDeck(items) {
		const cut01 = _shuffle(items.splice(0, Math.floor(_size(items) / 3)));
		const cut02 = (_size(items) > 0) ? _shuffle(items.splice(0, Math.ceil(_size(items) / 3))) : [];
		const cut03 = (_size(items) > 0) ? _shuffle(items) : [];

		return _shuffle(cut02.concat(cut01).concat(cut03));
	}

	handleClick(e, index) {
		if(!this.state.first_element) {
			this.state.first_element = index;
			this.movePlay();
		} else if(!this.state.last_element) {
			this.state.last_element = index;
			this.checkEquals();
		}

		this.setState({...this.state});
	}

	handleMouseOver(e, index) {
		const rec = this.refs['element_' + index];

		if(rec.attrs.fill == this.hidden_color){
			rec.fill(this.hidden_color_hover);
			this.refs.layer.draw();
		}
	}

	handleMouseOut(e, index) {
		const rec = this.refs['element_' + index];

		if(rec.attrs.fill == this.hidden_color_hover) {
			rec.fill(this.hidden_color);
			this.refs.layer.draw();
		}
		//this.setState({...this.state});
	}

	checkEquals() {
		const first_element = this.refs['element_' + this.state.first_element].attrs;
		const last_element = this.refs['element_' + this.state.last_element].attrs;

		var is_equal = false;
		var is_solve = false;
		if(first_element.identifier == last_element.identifier) {
			this.state.found.push({ id:first_element.identifier });
			is_equal = true;
			this.moveAndSuccessPlay();
			if(this.props.onHitResult != undefined) this.props.onHitResult();
		}else{
			this.movePlay();
		}

		if(_size(this.state.found) == _size(this.state.images)) {
			is_solve = true;
			if(this.props.onSolve != undefined) {
				this.props.onSolve(true, {img:this.refs['stage'].toDataURL()});
			}
		}

		if(this.props.onFireAttempt != undefined && !is_solve) this.props.onFireAttempt({
			error:!is_equal,
		},is_solve);

		setTimeout(() => {
			this.state.first_element = false;
			this.state.last_element = false;

			if(!is_equal) this.errorPlay();

			this.setState({...this.state});
		}, ((!is_equal) ? 500 : 50));
	}

	separateInRows() {
		const num_pairs = _size(this.state.images);
		if(num_pairs >= 3 && num_pairs <= 8) {
			var pos_arr = [];

			switch(num_pairs) {
				case 3:
					pos_arr = [1, 4, 1];
					break;
				case 4:
					pos_arr = [2, 4, 2];
					break;
				case 5:
					pos_arr = [3, 4, 3];
					break;
				case 6:
					pos_arr = [4, 4, 4];
					break;
				case 7:
					pos_arr = [3, 4, 4, 3];
					break;
				case 8:
					pos_arr = [4, 4, 4, 4];
					break;
			}

			return pos_arr;
		} else {
			return false;
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const items = this.state.items;
		const canvas_size = this.size;

		const img_positions = this.separateInRows();

		if(_size(img_positions) < 1) {
			return (
				<aside class="game_container is_memory">
					<div class="canvas_content">
						<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />
						<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
							<span>{i18n("Upload at least 3 different card images to generate the game")}</span>
							<span class="size_recommendation"><FormattedMessage id="Recommended size: {w}×{h}px" values={{w:250, h:250}} /></span>
						</div>
					</div>
				</aside>
			)
		}
		
		const bg_color = this.props?.bg_color ?? (((this.props?.theme ?? 'light') == 'light') ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 1)');
		const theme = isColorBright(RGB_2_HEX(bg_color)) ? 'light' : 'dark';

		const border_size = 2;
		const padding_size = 7;
		const size_portion = canvas_size / this.columns;
		const border_radius = [canvas_size / 100, canvas_size / 100, canvas_size / 100, canvas_size / 100];
		const border_radius_external = [canvas_size / 60, canvas_size / 60, canvas_size / 60, canvas_size / 60];

		let actual_column = 0;
		let actual_row = 0;

		const backflip_image = (this.state.backflip_image) ? this.state.backflip_image_obj : false;
		const slide_size_backflip = (backflip_image) ? canvas_size / this.columns / (Math.max(backflip_image.image_w, backflip_image.image_h)) : false;

		return (
			<aside class="game_container is_memory">
				{(_size(img_positions) > 0) ? (
					<div class={'canvas_content is_' + theme}>
						<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />
						{(this.state.full_loaded) ? (
							<Stage className={'canvas_cont' + ((!this.state.full_loaded) ? ' not_loaded_yet' : '')} width={canvas_size} height={canvas_size} ref="stage">
								<Layer ref="layer">
									<Rect
										x={0}
										y={0}
										fill={bg_color}
										width={this.size}
										height={this.size}
									/>

									{items.map((value, index) => {
										const A = (actual_column - (img_positions[actual_row] - 1) / 2);
										const B = (actual_row - (_size(img_positions) - 1) / 2);

										const x_deviation = A * (-0.7 * Math.abs(15 * B) + 15);
										const y_deviation = B * (-0.7 * Math.abs(15 * A) + 15);

										const x_ini = (actual_column + 1) * (canvas_size / (img_positions[actual_row] + 1)) + x_deviation;
										const y_ini = (actual_row + 1) * (canvas_size / (_size(img_positions) + 1)) + y_deviation;

										actual_column++;
										if(actual_column == img_positions[actual_row]) {
											actual_row++;
											actual_column = 0;
										}

										const positive_index = index + 1;

										const is_ok = this.state.found.filter((obj) => { return (obj.id == value.identifier) ? true : false; })[0];
										const show = (this.state.last_element === positive_index || this.state.first_element === positive_index || is_ok) ? true : false;

										const slide_size = canvas_size / this.columns / (Math.max(value.image_w, value.image_h));

										return (
											<Group
												ref={`element_${positive_index}`}
												key={`item-${positive_index}`}
												identifier={value.identifier}
												x={x_ini}
												y={y_ini}
												offsetX={size_portion / 2}
												offsetY={size_portion / 2}
												width={size_portion}
												height={size_portion}
												rotation={value.rotation}
												onClick={(!show) ? (e) => this.handleClick(e, positive_index) : null}
												onTap={(!show) ? (e) => this.handleClick(e, positive_index) : null}
												onMouseOver={(e) => this.handleMouseOver(e, positive_index)}
												onMouseOut={(e) => this.handleMouseOut(e, positive_index)}
												onMouseEnter={() => { document.body.style.cursor = ((!show) ? 'pointer' : 'default'); }}
												onMouseLeave={() => { document.body.style.cursor = 'default'; }}
											>
												<Rect
													width={size_portion + padding_size}
													height={size_portion + padding_size}
													x={-(padding_size) / 2}
													y={-(padding_size) / 2}
													cornerRadius={border_radius}
													shadowBlur={canvas_size / 80}
													shadowColor='rgba(0, 0, 0, 0.4)'
													shadowOffsetY={canvas_size / 80 / 2}
													fill={bg_color}
												/>

												{(!show && !backflip_image) && (
													<Rect
														width={size_portion}
														height={size_portion}
														cornerRadius={border_radius}
														fill={this.hidden_color}
													/>
												)}

												{(!show && backflip_image) && (
													<Rect
														width={size_portion}
														height={size_portion}
														cornerRadius={border_radius}
														fillPatternImage={backflip_image.fillPatternImage}
														//fillPatternRepeat='no-repeat' // this breaks in Firefox
														fillPatternScaleX={slide_size_backflip}
														fillPatternScaleY={slide_size_backflip}
														fillPatternOffsetX={slide_size_backflip / 2}
														fillPatternOffsetY={slide_size_backflip / 2}
													/>
												)}

												{(show) && (
													<Rect
														width={size_portion}
														height={size_portion}
														cornerRadius={border_radius}
														fillPatternImage={value.fillPatternImage}
														//fillPatternRepeat='no-repeat' // this breaks in Firefox
														fillPatternScaleX={slide_size}
														fillPatternScaleY={slide_size}
														fillPatternOffsetX={slide_size / 2}
														fillPatternOffsetY={slide_size / 2}
														//fillPatternX={(size_portion - slide_size * value.image_w) / 2}
														//fillPatternY={(size_portion - slide_size * value.image_h) / 2}
													/>
												)}

												<Rect
													width={size_portion + border_size + padding_size}
													height={size_portion + border_size + padding_size}
													x={-(border_size + padding_size) / 2}
													y={-(border_size + padding_size) / 2}
													strokeWidth={border_size}
													cornerRadius={border_radius_external}
													stroke={(theme == 'light') ? 'black' : 'white'}
												/>
											</Group>
										)
									})}
								</Layer>
							</Stage>
						) : (
							<div class="gui_not_in_top gui_flex_center">
								<Spinner>Loading game</Spinner>
							</div>
						)}
					</div>
				) : (
					<div class={`canvas_content is_${theme}`}>
						<p class="blackColor">{i18n("There are not enough cards to play the game")}</p>
					</div>
				)}
			</aside>
		);
	}
}
export default injectIntl(MemoryCanvas);